import React from 'react';
import { I18nextProvider } from 'react-i18next';
import { PregradingExams } from './pregrading-exams';
import i18next from '../locales/i18n';
import '../../less/grading-exams.less';
export const PregradingExamUrlsContext = React.createContext({});
export function Pregrading({ scopeId, roleType, allowedExams, pregradingExamUrls, examReviewRequired = false, examsDeletable = false, lang }) {
    return (React.createElement(I18nextProvider, { i18n: i18next(lang) },
        React.createElement(PregradingExamUrlsContext.Provider, { value: pregradingExamUrls },
            React.createElement(PregradingExams, { scopeId: scopeId, roleType: roleType, allowedExams: allowedExams, examReviewRequired: examReviewRequired, examsDeletable: examsDeletable }))));
}
//# sourceMappingURL=pregrading.js.map